import { render, staticRenderFns } from "./feedbackActions.vue?vue&type=template&id=444c3680"
import script from "./feedbackActions.vue?vue&type=script&lang=js"
export * from "./feedbackActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports